/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AllocationCompanyModel } from '../models/AllocationCompanyModel';
import type { CapTableDetailsModel } from '../models/CapTableDetailsModel';
import type { CapTableFundOwnership } from '../models/CapTableFundOwnership';
import type { CapTableGrossIRRResponse } from '../models/CapTableGrossIRRResponse';
import type { CapTableModel } from '../models/CapTableModel';
import type { CapTableSecurities } from '../models/CapTableSecurities';
import type { ProFormaCapTableModel } from '../models/ProFormaCapTableModel';
import type { UpdateFundOwnershipResponse } from '../models/UpdateFundOwnershipResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CapTablesService {
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static apiCapTablesFundOwnershipDetailsDelete(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/cap-tables/fund-ownership-details/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param data
     * @returns ProFormaCapTableModel
     * @throws ApiError
     */
    public static apiCapTablesProFormaCreate(
        data: ProFormaCapTableModel,
    ): CancelablePromise<ProFormaCapTableModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/cap-tables/pro-forma',
            body: data,
        });
    }
    /**
     * @param id A unique integer value identifying this cap table.
     * @returns CapTableDetailsModel
     * @throws ApiError
     */
    public static apiCapTablesRead(
        id: number,
    ): CancelablePromise<CapTableDetailsModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/cap-tables/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id A unique integer value identifying this cap table.
     * @param data
     * @returns CapTableDetailsModel
     * @throws ApiError
     */
    public static apiCapTablesUpdate(
        id: number,
        data: CapTableDetailsModel,
    ): CancelablePromise<CapTableDetailsModel> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/cap-tables/{id}',
            path: {
                'id': id,
            },
            body: data,
        });
    }
    /**
     * @param id A unique integer value identifying this cap table.
     * @param data
     * @returns CapTableDetailsModel
     * @throws ApiError
     */
    public static apiCapTablesPartialUpdate(
        id: number,
        data: CapTableDetailsModel,
    ): CancelablePromise<CapTableDetailsModel> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/cap-tables/{id}',
            path: {
                'id': id,
            },
            body: data,
        });
    }
    /**
     * @param id A unique integer value identifying this cap table.
     * @returns CapTableDetailsModel
     * @throws ApiError
     */
    public static apiCapTablesAllBreakpointsRead(
        id: number,
    ): CancelablePromise<CapTableDetailsModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/cap-tables/{id}/all-breakpoints',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id A unique integer value identifying this cap table.
     * @param data
     * @returns CapTableDetailsModel
     * @throws ApiError
     */
    public static apiCapTablesAllBreakpointsUpdate(
        id: number,
        data: CapTableDetailsModel,
    ): CancelablePromise<CapTableDetailsModel> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/cap-tables/{id}/all-breakpoints',
            path: {
                'id': id,
            },
            body: data,
        });
    }
    /**
     * @param id A unique integer value identifying this cap table.
     * @param data
     * @returns CapTableDetailsModel
     * @throws ApiError
     */
    public static apiCapTablesAllBreakpointsPartialUpdate(
        id: number,
        data: CapTableDetailsModel,
    ): CancelablePromise<CapTableDetailsModel> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/cap-tables/{id}/all-breakpoints',
            path: {
                'id': id,
            },
            body: data,
        });
    }
    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static apiCapTablesCheckAssociatedMeasurementDateList(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/cap-tables/{id}/check-associated-measurement-date',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id A unique integer value identifying this fund ownership.
     * @returns CapTableFundOwnership
     * @throws ApiError
     */
    public static apiCapTablesFundOwnershipRead(
        id: number,
    ): CancelablePromise<CapTableFundOwnership> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/cap-tables/{id}/fund-ownership',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id A unique integer value identifying this fund ownership.
     * @param data
     * @returns UpdateFundOwnershipResponse
     * @throws ApiError
     */
    public static apiCapTablesFundOwnershipUpdate(
        id: number,
        data: CapTableFundOwnership,
    ): CancelablePromise<UpdateFundOwnershipResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/cap-tables/{id}/fund-ownership',
            path: {
                'id': id,
            },
            body: data,
        });
    }
    /**
     * @param id A unique integer value identifying this fund ownership.
     * @param data
     * @returns CapTableFundOwnership
     * @throws ApiError
     */
    public static apiCapTablesFundOwnershipPartialUpdate(
        id: number,
        data: CapTableFundOwnership,
    ): CancelablePromise<CapTableFundOwnership> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/cap-tables/{id}/fund-ownership',
            path: {
                'id': id,
            },
            body: data,
        });
    }
    /**
     * @param id
     * @returns AllocationCompanyModel
     * @throws ApiError
     */
    public static apiCapTablesGotFinalAllocationRead(
        id: string,
    ): CancelablePromise<AllocationCompanyModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/cap-tables/{id}/got-final-allocation',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get gross IRR for a specific cap table and fund
     * Computes the gross IRR for the specified cap table and fund using the provided unrealized value at the given exit_date.
     * @param id A unique integer value identifying this cap table.
     * @param fund
     * @param unrealizedValue
     * @param exitDate
     * @returns CapTableGrossIRRResponse
     * @throws ApiError
     */
    public static apiCapTablesGrossIrrRead(
        id: number,
        fund: number,
        unrealizedValue: string,
        exitDate: string,
    ): CancelablePromise<CapTableGrossIRRResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/cap-tables/{id}/gross-irr',
            path: {
                'id': id,
            },
            query: {
                'fund': fund,
                'unrealized_value': unrealizedValue,
                'exit_date': exitDate,
            },
        });
    }
    /**
     * pk here is id of the company measurement date we're querying a primary captable for
     * @param id A unique integer value identifying this cap table.
     * @returns CapTableDetailsModel
     * @throws ApiError
     */
    public static apiCapTablesPrimaryRead(
        id: number,
    ): CancelablePromise<CapTableDetailsModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/cap-tables/{id}/primary',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param data
     * @returns CapTableSecurities
     * @throws ApiError
     */
    public static apiCapTablesSecuritiesUpdate(
        id: string,
        data: CapTableSecurities,
    ): CancelablePromise<CapTableSecurities> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/cap-tables/{id}/securities',
            path: {
                'id': id,
            },
            body: data,
        });
    }
    /**
     * @param id
     * @param data
     * @returns CapTableSecurities
     * @throws ApiError
     */
    public static apiCapTablesSecuritiesPartialUpdate(
        id: string,
        data: CapTableSecurities,
    ): CancelablePromise<CapTableSecurities> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/cap-tables/{id}/securities',
            path: {
                'id': id,
            },
            body: data,
        });
    }
    /**
     * @param id A unique integer value identifying this cap table.
     * @param data
     * @returns CapTableModel
     * @throws ApiError
     */
    public static apiCapTablesToggleWaterfallVisibilityUpdate(
        id: number,
        data: CapTableModel,
    ): CancelablePromise<CapTableModel> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/cap-tables/{id}/toggle-waterfall-visibility',
            path: {
                'id': id,
            },
            body: data,
        });
    }
    /**
     * @param id A unique integer value identifying this cap table.
     * @param data
     * @returns CapTableModel
     * @throws ApiError
     */
    public static apiCapTablesToggleWaterfallVisibilityPartialUpdate(
        id: number,
        data: CapTableModel,
    ): CancelablePromise<CapTableModel> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/cap-tables/{id}/toggle-waterfall-visibility',
            path: {
                'id': id,
            },
            body: data,
        });
    }
}
